export const LOTS_TO_DISPLAY_IN_CAROUSEL = 3;
